import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';
import HeadingWithButtons, { IHeadingWithButtonsProps } from '../../Components/HeadingWithButtons';
import Block from '../../Components/Block';

export interface ILayoutOverlayProps extends IHeadingWithButtonsProps {
    /** className to append */
    className?: string;
    /** className to append to heading container */
    headingClassName?: string;
    /** className to append to content container */
    contentClassName?: string;
    /** Container size */
    size?: 'default' | 'max' | 'wide' | 'medium' | 'small';
    /** Make content scrollable */
    scrollableContent?: boolean;
}

interface IState {

}

/**
 * Basic list wrapper.
 */
class LayoutOverlay extends React.Component<ILayoutOverlayProps, IState> {
    static displayName: string = 'LayoutOverlay';

    private nodeScroller;
    private cachedClientY = 0;
    private preventTouchBubbling = this.handlePreventTouchBubbling.bind(this);
    private cacheClientY = this.handleCacheClientY.bind(this);

    handlePreventTouchBubbling (event) {
        if (this.nodeScroller && this.nodeScroller.clientHeight >= this.nodeScroller.scrollHeight) {
            return;
        }

        if (event.targetTouches.length !== 1) {
            return;
        }

        const clientY = event.targetTouches[0].clientY - this.cachedClientY;

        if (this.nodeScroller.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }

        if ((this.nodeScroller.scrollHeight - this.nodeScroller.scrollTop <= this.nodeScroller.clientHeight) && clientY < 0) {
            event.preventDefault();
        }

    }

    handleCacheClientY (event) {
        if (this.nodeScroller && this.nodeScroller.clientHeight >= this.nodeScroller.scrollHeight) {
            return;
        }

        if (event.targetTouches.length !== 1) {
            return;
        }
        this.cachedClientY = event.targetTouches[0].clientY;
    }

    render () {
        return (
            <div className={classNames('layout-overlay', {
                'size-default': this.props.size === 'default' || !this.props.size,
                'size-max': this.props.size === 'max',
                'size-wide': this.props.size === 'wide',
                'size-medium': this.props.size === 'medium',
                'size-small': this.props.size === 'small',
            }, this.props.className)}>
                <div className="layout-overlay-inner">
                    <div className="layout-overlay-inner-wrapper">
                        {this.props.title && (
                            <Block className={classNames('layout-overlay-heading', this.props.headingClassName)}>
                                <HeadingWithButtons
                                    icon={this.props.icon}
                                    level={3}
                                    title={this.props.title}
                                    buttons={this.props.buttons}
                                    buttonIcons={this.props.buttonIcons}
                                />
                            </Block>
                        )}
                        <div
                            className="layout-overlay-content"
                            ref={(node) => {
                                if (node) {
                                    this.nodeScroller = node;
                                    node.addEventListener('touchstart', this.cacheClientY, { passive: false });
                                    node.addEventListener('touchmove', this.preventTouchBubbling, { passive: false });
                                }
                            }}
                        >
                            <div className="layout-overlay-content-wrapper alternate-blocks">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LayoutOverlay;
